var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseWidget',{attrs:{"item":_vm.item}},[_c('div',[_c('StrapiMarkdownComponent',{attrs:{"item":_vm.item.contenu}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }